// 金額轉換：伺服器整數金額 ↔ 客戶端顯示數值。對應 Unity ServiceUtils.ToClientBalance。
// 後端為避免浮點精度問題，金額一律以「真實值 × 10000」的整數傳遞；
// 前端顯示時除以 10000、保留兩位小數（見 format.ts formatMoney）。
const BALANCE_FACTOR = 10_000

/**
 * 將伺服器整數金額轉為顯示用數值（÷10000）。
 * 例：伺服器 10000 → 顯示 1；伺服器 12345 → 顯示 1.2345（呈現時由 formatMoney 取兩位）。
 */
export function toClientBalance(raw: bigint): number {
  return Number(raw) / BALANCE_FACTOR
}

/** 顯示數值 → 伺服器整數金額（×10000，四捨五入避免浮點殘差）。 */
export function toServerBalance(value: number): number {
  return Math.round(value * BALANCE_FACTOR)
}
